var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[(_vm.$route.path==='/conta' ? false : true)?_c('NavBar'):_vm._e(),_c('notifications',{attrs:{"position":"top right"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }